<template>
  <v-row
    align="center"
    justify="end"
  >
    <Button
      v-if="showActivatorText"
      :color="!!activatorText ? 'third' : null"
      :plain="!activatorText"
      class="font-weight-bold my-3 d-flex justify-center"
      :outlined="!!activatorText"
      :action="openPopUp"
      :label="activatorText"
      :icon="icon"
      :icon-color="!!activatorText ? 'third' : null"
    />

    <v-overlay
      :value="popup"
      opacity="0.5"
      z-index="10000"
    >
      <v-container>
        <v-card
          class="pa-5"
          :style="hasWidth"
          light
        >
          <div>
            <div class="full-width d-flex justify-end">
              <v-btn icon @click="closeOverlay()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="pb-4 pt-0 mt-0"
              @click.stop
            />
            <v-data-table
              id="singleTablePopUp"
              v-model="newValue"
              :items="list"
              :search="search"
              :headers="headers"
              :hide-default-footer="true"
              :items-per-page="-1"
              :hide-default-header="true"
              height="350"
              show-select
              item-key="uuid"
              :custom-filter="filter"
              :single-select="singleSelect"
              @item-selected="selectItem"
              @click:row="rowClick"
            >
              <template #item.name="{ item }">
                {{ item[field] }}
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-container>
    </v-overlay>
  </v-row>
</template>

<script>
import { ref, watch, computed } from '@vue/composition-api';
import Button from './common/Button.vue';
import { EventBus } from '@/helpers/utils';

export default {
  components: { Button },
  props: {
    value: {
      type: Object,
      default () {
        return {};
      }
    },
    list: {
      type: Array,
      default () {
        return [];
      }
    },
    icon: {
      type: String,
      default: ''
    },
    field: {
      type: String,
      default: ''
    },
    singleSelect: { type: Boolean },
    width: {
      type: String,
      default: ''
    },
    activatorText: {
      type: String,
      default: null
    },
    showActivatorText: {
      type: Boolean,
      default: true
    }
  },
  setup (props, context) {
    const search = ref(null);
    const popup = ref(false);
    const newValue = ref([props.value]);
    const headers = computed(() => [
      { text: 'Nom', value: 'name', sortable: false }
    ]);

    const filter = (_, searchValue, item) => item[props.field].toLowerCase().includes(searchValue.toLowerCase());

    const closeOverlay = () => {
      popup.value = false;
    };

    // v-model
    watch(newValue, () => {
      context.emit('input', newValue.value[0]);
    });

    watch(() => props.value, () => {
      newValue.value = [props.value];
    });

    const hasWidth = computed(() => (props.width ? `width:${props.width}px;` : null));

    /**
     * value contains 2 props
     * value -> represent if the item was selected or not (true or false)
     * item-> represent the select item
     */
    const selectItem = value => {
      // single select on session detail -> no need to populate participant horse list
      const emitVal = value.value ? value.item : {};
      context.emit('input', emitVal);
      closeOverlay();
    };

    const rowClick = (item, row) => {
      event.stopPropagation();
      row.select(!row.isSelected);
      closeOverlay();
    };

    const openPopUp = () => {
      popup.value = true;
    };

    EventBus.$on('showSingleTablePopUp', () => {
      openPopUp();
    });

    return { openPopUp, headers, search, popup, newValue, filter, selectItem, rowClick, hasWidth, closeOverlay };
  }
};
</script>

<style>
  #singleTablePopUp > div > table{
    table-layout: auto;
  }
  #singleTablePopUp tr {
    cursor: pointer;
  }
</style>
